module.exports = __webpack_public_path__ + "static/media/mortgage-coach-success.c56d2b02.gif";